<template>
  <div
    class="small-scrollbar"
    style="width: 400px">
    <div
      class="d-flex w-100 mt-2 px-2"
      style="flex-wrap: wrap; align-items: center">
      <p
        class="py-1 flex-grow-1"
        style="font-family: Arial; font-size: 16px; font-weight: 700; line-height: 22px; letter-spacing: 0.01em; text-align: left; margin-top: 8px">
        Tin nhắn mẫu ({{ messageCount }})
      </p>
      <div
        class="d-flex align-items-center"
        style="gap: 5px">
        <el-input
          class="mb-2"
          placeholder="Tìm kiếm"
          v-model="searchKey"
          @input="searchQuickReplyList"
          size="small"
          style="width: 200px">
          <IconV2
            slot="prefix"
            class="my-2 ms-1"
            name="v2-search" />
        </el-input>

        <button
          class="close-btn"
          @click="closePopup"
          style="background: none; border: none; font-size: 25px; cursor: pointer; padding-bottom: 12px">
          &times;
        </button>
      </div>
    </div>

    <div style="background-color: white; height: 420px; max-width: 420px; overflow-y: auto">
      <el-col
        v-for="(quick, index) in getList()"
        :key="index"
        style="margin-bottom: 4px">
        <div
          style="border-top: 1px solid #eee; padding: 8px; cursor: pointer"
          @click="handleClick(quick)">
          <el-row
            style="
              color: black;
              background-color: #e1edfd;
              display: inline-block;
              padding: 4px;
              border-radius: 4px;
              font-family: Arial;
              font-size: 14px;
              font-weight: 700;
              line-height: 20px;
              letter-spacing: 0.01em;
              text-align: left;
            ">
            /{{ quick.code }}
          </el-row>
          <el-row
            class="mt-2"
            style="word-break: break-all; font-family: Arial; font-size: 14px; font-weight: 400; line-height: 20px; letter-spacing: 0.01em; text-align: left">
            {{ quick.content }}
          </el-row>
          <el-row
            style="overflow: hidden; text-overflow: ellipsis; display: flex; flex-wrap: wrap"
            class="mt-2">
            <div
              v-for="(item, index) in quick.urls"
              :key="index"
              style="width: 28px; height: 28px; margin-right: 4px"
              class="custom-el-image">
              <el-image
                style="width: 100%; height: 100%; object-fit: cover"
                :src="item.url" />
            </div>
          </el-row>
        </div>
      </el-col>
    </div>

    <div
      class="d-flex justify-content-center align-items-center"
      style="background-color: #eaecf2; padding: 10px; cursor: pointer; gap: 8px"
      @click="$router.push('/setting#quick-messages')">
      <div style="color: #1769d7; font-size: 13px; text-align: center; padding-left: 8px">Nhập / vào ô tin nhắn để hiển thị danh sách tin nhắn mẫu</div>
      <icon-v-2
        name="v2-setting"
        color="#1769d7"
        style="padding-top: 0px; padding-right: 8px"></icon-v-2>
    </div>
  </div>
</template>

<script>
import { removeVietnameseTones } from "../lib/text-utils";

export default {
  data() {
    return {
      searchKey: "",
      timeout: null,
      quickMessageListShow: [],
      filtering: false,
    };
  },
  props: {
    conversation: {
      type: Object,
    },
  },
  computed: {
    messageCount() {
      return this.getList().length;
    },
  },
  methods: {
    handleClick(mess) {
      this.searchKey = "";
      this.$emit("selectedMessage", mess);
    },
    searchQuickReplyList() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getList();
      }, 500);
    },
    getList() {
      let filteredMessages = (this.quickMessageListShow.length >= 0 && this.filtering == true) ? this.quickMessageListShow : this.app.quickReplyList;

      if (this.searchKey) {
        filteredMessages = filteredMessages.filter((msg) => {
          return (
            removeVietnameseTones(msg.content.toLowerCase()).includes(this.searchKey.toLowerCase()) ||
            msg.content.toLowerCase().includes(this.searchKey.toLowerCase()) ||
            msg.code.toLowerCase().includes(this.searchKey.toLowerCase())
          );
        });
      }
      const currentAccountId = this.conversation.accountId;

      filteredMessages = filteredMessages.filter((msg) => msg.accountId === "0" || msg.accountId === currentAccountId);

      filteredMessages.sort((a, b) => a.code.localeCompare(b.code));

      if (this.content && this.content.startsWith("/")) {
        return filteredMessages.filter((msg) => ("/" + msg.code).startsWith(this.content));
      }

      return filteredMessages;
    },

    splitComma(ids) {
      return ids ? ids.split(",") : [];
    },
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="scss">
.custom-el-image .el-image__inner {
  border-radius: 4px !important;
}
</style>
